export default "/images/123-milhas-logo.svg?9789b3faf39e1f3950fe58e1e88c4d9d";